var SearchApp = window.SearchApp || {};

SearchApp.Widget = function(url, decodeService, $input, $resultContainer) {
	// Constants
	var ANIMATION_DURATION = 300;
	var SEARCH_DELAY = 500;

	// Public Events
	this.allResultsClicked = new signals.Signal();
	this.symbolSelected = new signals.Signal();

	// Public Methods
	this.getQuery = getQuery;
	this.setQuery = setQuery;
	this.showSuggestions = showSuggestions;
	this.hideSuggestions = hideSuggestions;
	this.abortHide = abortHide;
	this.directLookup = directLookup;
	this.showSearchResults = showSearchResults;

	// Private Fields
	var self = this;
	var searchThread = null;
	var searchRequest = null;
	var hideThread = null;
	var loadedQuery = '';
	var directLookupTrigged = false;

	// Constructor
	activate();
	function activate() {
		assert(typeof url === 'string', 'url is not a string');
		assert(decodeService instanceof SearchApp.DecodeService, 'decodeService is not a DecodeService');
		assert($input instanceof jQuery, '$input is not a jQuery');
		assert($resultContainer instanceof jQuery, '$resultContainer is not a jQuery');

		$resultContainer.on('click', '#search-show-popup-button', function(event) { showAllResults(event); });
		$resultContainer.on('click', '.search-link',
			function(event) { searchResultLinkClicked($(event.currentTarget)); });
	}

	// Private Mothods
	function getQuery() {
		return $input.val();
	}

	function setQuery(query) {
		$input.val(query);
		self.showSuggestions();
	}

	function showSuggestions() {
		self.abortHide();
		var query = $input.val();
		if (query === loadedQuery) {
			return;
		}

		if (query === '') {
			hidePopup();
			return;
		}

		abortSearch();
		searchThread = window.setTimeout(
			function() {loadSearchResults(query);},
			SEARCH_DELAY);
	}


	function isDescendant(parent, child) {
		var node = child[0].parentNode;
		if (child[0] == parent[0]) {
			return true;
		}
		while (node != null) {
			if (node == parent[0]) {
				return true;
			}
			node = node.parentNode;
		}
		return false;
	}

	function hideSuggestions() {
		// Only set the timeout to close once the focused element is not the results container on in the results container
		var isFocusedElementInContainer = isDescendant($resultContainer,$(document.activeElement));
		if (hideThread === null && !isFocusedElementInContainer) {
			hideThread = window.setTimeout(hidePopup, SEARCH_DELAY);
		}
	}

	function abortHide() {
		if (hideThread !== null) {
			window.clearTimeout(hideThread);
			hideThread = null;
		}
	}

	function directLookup() {
		directLookupTrigged = true;
		var isLoading = searchThread !== null ||
			searchRequest !== null;
		if (!isLoading) {
			directLookupImmediately();
		}
	}

	function showSearchResults(query, result) {
		searchRequest = null;
		loadedQuery = query;
		$resultContainer.hideLoader();
		$resultContainer.html(result);
		directLookupImmediately();
	}

	function searchResultLinkClicked($link) {
		var data = $link.data();
		decodeService.decode(data, function(xid) {
			self.symbolSelected.dispatch(xid, data);
		});
	}

	function abortSearch() {
		if (searchRequest !== null) {
			searchRequest.abort();
			searchRequest = null;
		}

		if (searchThread !== null) {
			window.clearTimeout(searchThread);
			searchThread = null;
		}
	}

	function shopPopup() {
		$resultContainer
			.fadeTo(ANIMATION_DURATION, 1) // fadeId does not work for the second time
			.showLoader();
	}

	function hidePopup() {
		abortSearch();
		loadedQuery = '';
		$resultContainer
			.fadeOut(ANIMATION_DURATION, 0, function() {$resultContainer.html('');});
	}

	function loadSearchResults(query) {
		abortSearch();
		shopPopup();

		var data = {query: query};
		searchRequest = $.get(url, data, 'html');
		searchRequest.then(function(result) {
			self.showSearchResults(query, result);
		});
	}

	function directLookupImmediately() {
		if (!directLookupTrigged) {
			return;
		}

		directLookupTrigged = false;

		var $exactMatch = $resultContainer.find('.search-link[data-symbol]');
		if ($exactMatch.length) {
			searchResultLinkClicked($exactMatch);
		}
	}

	function showAllResults(event) {
		// Dispatch allResultsClicked event
		self.allResultsClicked.dispatch(event);

		// Close search popup
		hidePopup();
	}
};
